module.exports = __webpack_public_path__ + "img/camera.366b6279.svg";